import Vue from 'vue';
import Vuex from 'vuex';

import { State } from './state';
import Mutations from './mutations';
import Actions from './actions';
import Getters from './getters';

import { filterStoreModule } from './modules/filter-store-module';
import { scopeStoreModule } from './modules/scope-store-module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: new State,
    mutations: Mutations,
    actions: Actions,
    getters: Getters,
    modules: {
        filter: filterStoreModule,
        scope: scopeStoreModule
    }
})